import { Component, Input, OnDestroy } from '@angular/core';

import { Observable, Subscription } from 'rxjs/Rx';

import { Event, Venue, FileInclMetaData, FileMediaData, FileObject } from "app/models";
import { StringDatePipe } from './../string-date.pipe';
import { FileApi } from 'app/services/webservice';

let moment = require("moment")

@Component({
	selector: 'event-info',
	templateUrl: "./event-info.html",
	styles: [require("./event-info.scss")]
})

export class EventInfo {

	@Input() venue: Venue

	private _event: Event
	private doorsOpenTime: string;
	private imageFile: FileObject;
	private imageSubscription: Subscription

	@Input() set event(event: Event){
		if (event) {
			this._event = event;
			this.doorsOpenTime = this.calcdoorsOpenTime(event.begin, event.doorsOpenOffset);
			this.getImage(event.images[0]);
		}
	}

	constructor(public fileApi: FileApi) {};

	ngOnDestroy() {
		if (this.imageSubscription) {
			this.imageSubscription.unsubscribe();
		}
	}

	private calcdoorsOpenTime(begin: string, doorsOpenOffset: number): string {
		const beginMoment = moment(begin, "YYYY-MM-DD'T'HH:mm:ss");
		const doorsOpenMoment = beginMoment.subtract(doorsOpenOffset, 'minutes');
		const doorsOpenTime = doorsOpenMoment.format("HH:mm");
		return doorsOpenTime
	}

	private getImage(mediaData: FileMediaData): void {
		if (!mediaData) {
			return;
		}

		this.imageSubscription = this.fileApi.getFileInclMetaData(mediaData.fileMetaDataId).subscribe(
			(imageFile: FileInclMetaData) => {
				this.imageFile = FileObject.fromFileInclMetaData(imageFile);
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/event-info/event-info.component.ts